import React, { useState, useEffect } from "react";
import "./styles/Card.css";

const Card = ({ index, item, onClick, addToCart, products }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        if (item.Img && item.Img.length > 0 && isHovered) {
            const interval = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % item.Img.length);
            }, 5000);

            return () => clearInterval(interval);
        }
    }, [item.Img, isHovered]);

    const handleReadMore = (e) => {
        e.stopPropagation(); // Prevents the card click event from triggering
        setIsExpanded(!isExpanded);
    };

    const handleAddToCart = (e) => {
        e.stopPropagation();
        addToCart(item, 1);
    };

    const handleNextImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % item.Img.length);
    };

    const handlePrevImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + item.Img.length) % item.Img.length);
    };

    return (
        <div
            key={index}
            className="item-card"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {item.isCombo ? (
                <div className="product-grid">
                    {Array.isArray(item.Products) &&
                        item.Products.map((productName, i) => {
                            const comboProduct = products?.[productName]; // Get combo product details
                            return (
                                <img
                                    key={i}
                                    src={comboProduct?.Img?.[0] || "/placeholder.jpg"}
                                    alt={comboProduct?.Name || "Unknown Product"}
                                    className="combo-image"
                                />
                            );
                        })}
                </div>
            ) : (
                <div className="item-image">
                    <button className="prev-button" onClick={handlePrevImage}>&lt;</button>
                    <img src={item.Img?.[currentImageIndex] || "/placeholder.jpg"} alt={item.Name} className="item-image" />
                    <button className="next-button" onClick={handleNextImage}>&gt;</button>
                    <div className="dots-container">
                        {item.Img.map((_, index) => (
                            <span
                                key={index}
                                className={`dot ${index === currentImageIndex ? "active" : ""}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentImageIndex(index);
                                }}
                            ></span>
                        ))}
                    </div>
                </div>
            )}
            <div className="item-details">
                <h3>{item.Name}</h3>
                <div className="price-weight-list">
                    Rs. {item.Price}&nbsp;&nbsp;|&nbsp;&nbsp;{item.Net_Wt} {item.Net_Wt_Unit}
                </div>
                <div className="item-card-desc">
                    {isExpanded ? item["Desc"] : `${item["Desc"].slice(0, 50)}... `}
                    {!isExpanded && item["Desc"].length > 50 && (
                        <span className="read-more" onClick={handleReadMore}>
                            (Read more)
                        </span>
                    )}
                    {isExpanded && (
                        <span className="read-less" onClick={handleReadMore}>
                            (Read less)
                        </span>
                    )}
                </div>

                <div className="card-actions">
                    <button className="ATC-button" onClick={handleAddToCart}>
                        Add to Cart
                    </button>
                </div>

            </div>
        </div>
    );
};

export default Card;


